var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M20.756 5.345C20.565 5.126 20.29 5 20 5H6.181L5.986 3.836C5.906 3.354 5.489 3 5 3H2.75C2.197 3 1.75 3.447 1.75 4C1.75 4.553 2.197 5 2.75 5H4.153L6.013 16.164C6.021 16.209 6.044 16.246 6.058 16.288C6.074 16.341 6.087 16.391 6.112 16.439C6.144 16.505 6.187 16.561 6.232 16.618C6.263 16.657 6.291 16.696 6.327 16.73C6.385 16.784 6.452 16.822 6.52 16.86C6.558 16.881 6.591 16.909 6.632 16.925C6.748 16.972 6.87 17 6.999 17H18C18.553 17 19 16.553 19 16C19 15.447 18.553 15 18 15H7.847L7.681 14H19C19.498 14 19.92 13.634 19.99 13.142L20.99 6.142C21.031 5.854 20.945 5.563 20.756 5.345ZM18.847 7L18.562 9H15V7H18.847ZM14 7V9H11V7H14ZM14 10V12H11V10H14ZM10 7V9H7C6.947 9 6.899 9.015 6.852 9.03L6.514 7H10ZM7.014 10H10V12H7.347L7.014 10ZM15 12V10H18.418L18.133 12H15Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 21C9.32843 21 10 20.3284 10 19.5C10 18.6716 9.32843 18 8.5 18C7.67157 18 7 18.6716 7 19.5C7 20.3284 7.67157 21 8.5 21Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.5 21C18.3284 21 19 20.3284 19 19.5C19 18.6716 18.3284 18 17.5 18C16.6716 18 16 18.6716 16 19.5C16 20.3284 16.6716 21 17.5 21Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }